import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCamera, FaTag, FaRocket, FaClipboardList, FaCheckCircle } from "react-icons/fa";
import "./info-page.css";

const TIPS = [
  {
    icon: <FaClipboardList size={24} color="#ed1b24" />,
    title: "Add as Much Detail as You Can",
    points: [
      "Include relevant keywords buyers are likely to search for — make, model, year, fuel type and condition.",
      "Be honest and accurate in your description. Buyers trust detailed, transparent listings.",
      "Mention any extras: service history, recent repairs, accessories included.",
      "Ads with complete details receive significantly more views and enquiries.",
    ],
  },
  {
    icon: <FaCamera size={24} color="#ed1b24" />,
    title: "Add Great Photos",
    points: [
      "Real, high-quality photos can get up to 10× more views than listings without images.",
      "Photograph the exterior from multiple angles — front, sides and rear.",
      "Include interior shots: dashboard, seats, boot and any notable features.",
      "Shoot in good natural lighting and avoid cluttered backgrounds.",
    ],
  },
  {
    icon: <FaTag size={24} color="#ed1b24" />,
    title: "Pick the Right Price",
    points: [
      "Browse similar listings on AdsOne to benchmark your asking price against the current market.",
      "A competitively priced vehicle attracts more buyers and sells faster.",
      "Mark your ad as 'Negotiable' if you are open to offers — it encourages more enquiries.",
      "Overpriced listings often stay unsold for weeks; a fair price sells quickly.",
    ],
  },
  {
    icon: <FaRocket size={24} color="#ed1b24" />,
    title: "Boost Your Ad",
    points: [
      "After posting, use the Boost feature to push your listing to the top of search results.",
      "Boosted ads can receive up to 10× more views and reach far more potential buyers.",
      "Premium placements keep your vehicle visible even as newer ads are posted.",
      "Log in to Ad Settings to boost any of your active listings at any time.",
    ],
  },
];

function SellFastPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Seller Tips</p>
            <h1 className="info-page__title">How to Sell Your Vehicle Fast</h1>
            <p className="info-page__subtitle">
              Follow these simple tips to get more views, more enquiries and a quicker sale on AdsOne.
            </p>
            <Link to="/create-ad" className="btn btn-danger px-4 py-2 fw-bold" style={{ borderRadius: "50rem" }}>
              Post a Free Ad
            </Link>
          </div>

          {/* Tips */}
          <div className="info-page__body">
            {TIPS.map((tip, i) => (
              <div key={i} className="info-section">
                <div className="info-section__icon-wrap">{tip.icon}</div>
                <div className="info-section__content">
                  <h3 className="info-section__title">{tip.title}</h3>
                  <ul className="info-section__list">
                    {tip.points.map((p, j) => (
                      <li key={j}>
                        <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="info-page__cta">
            <h3>Ready to sell?</h3>
            <p>Post your vehicle listing for free and reach thousands of buyers across Sri Lanka.</p>
            <Link to="/create-ad" className="btn btn-danger px-5 py-2 fw-bold" style={{ borderRadius: "50rem" }}>
              Post a Free Ad Now
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SellFastPage;
